<template>
  <div id="app" class="container">
    <!-- Header -->
    <h1 class="page-title">YouTube Trending Videos</h1>

    <!-- Filter Panel -->
    <div class="filter-panel">
      <!-- Mode selection -->
      <div class="form-group">
        <label class="label">Mode:</label>
        <div class="radio-group">
          <label>
            <input type="radio" value="daily" v-model="mode" /> Daily
          </label>
          <label>
            <input type="radio" value="weekly" v-model="mode" /> Weekly
          </label>
        </div>
      </div>

      <!-- Date Picker -->
      <div class="form-group" v-if="mode === 'daily'">
        <label for="dayPicker" class="label">Select Day:</label>
        <input id="dayPicker" type="date" v-model="day_start" />
      </div>
      <div class="form-group" v-else>
        <label for="weekPicker" class="label">Select Week:</label>
        <input id="weekPicker" type="week" v-model="week_input" @change="updateWeekStart" />
      </div>

      <div class="form-group">
        <label class="label">
          <input type="checkbox" v-model="ooOnly" /> Managed Videos
        </label>
      </div>

      <!-- Category Selection -->
      <div class="form-group">
        <label for="category" class="label">Select Category:</label>
        <select id="category" v-model.number="trend_category">
          <option :key="0" :value="0">All Categories</option>
          <option v-for="item in sortedCategories" :key="item.id" :value="item.id">
            {{ item.label }}
          </option>
        </select>
      </div>

      <!-- Search Button -->
      <button class="submit-button" @click="checkInputAndSearch()">Search</button>
    </div>

    <!-- Video Results -->
    <div class="video-grid">
      <div class="video-card" v-for="(column, index) in columns" :key="index">
        <div
          v-for="(video, vIndex) in column.results"
          :key="`video-${index}-${vIndex}`"
          class="video-tile"
          :class="{ 'oo-owned': video.video_type === 'own' }"
        >
          <img :src="`https://img.youtube.com/vi/${video.video_id}/hqdefault.jpg`" alt="Video Thumbnail" class="video-thumb" />
          <div class="video-meta">
            <h3 class="video-title">{{ video.title }}</h3>
            <p>Rank: {{ video.avg_trend_rank }}</p>
            <p>Views: {{ video.total_views }}</p>
            <p>Likes: {{ video.total_likes }}</p>
            <p>Comments: {{ video.total_comments }}</p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
//import { API } from "aws-amplify";
import axios from 'axios';
import "@/assets/css/styles.css";

export default {
  name: 'Trending',
  data() {
    return {
      baseURL: 'https://de-web-app.de.dev.internal.spotter.la',
      day_start: '2025-03-09',
      week_start: '2025-03-09',
      week_input: '',
      trend_category: 20,
      mode: 'daily',
      columns: [
        { results: [] },
      ],
      categories: {
        1: 'Film & Animation',
        2: 'Autos & Vehicles',
        10: 'Music',
        15: 'Pets & Animals',
        17: 'Sports',
        18: 'Short Movies',
        19: 'Travel & Events',
        20: 'Gaming',
        21: 'Videoblogging',
        22: 'People & Blogs',
        23: 'Comedy',
        24: 'Entertainment',
        25: 'News & Politics',
        26: 'Howto & Style',
        27: 'Education',
        28: 'Science & Technology',
        29: 'Nonprofits & Activism',
        30: 'Movies',
        31: 'Anime/Animation',
        32: 'Action/Adventure',
        33: 'Classics',
        35: 'Documentary',
        36: 'Drama',
        37: 'Family',
        38: 'Foreign',
        39: 'Horror',
        40: 'Sci-Fi/Fantasy',
        41: 'Thriller',
        42: 'Shorts',
        43: 'Shows',
        44: 'Trailers'
      }
    };
  },
  computed: {
    sortedCategories() {
      return Object.entries(this.categories)
        .map(([id, label]) => ({ id: parseInt(id), label }))
        .sort((a, b) => a.label.localeCompare(b.label));
    }
  },
  created() {
    // Local
    //this.api = "/yt_trending/daily";
    this.api = `${this.baseURL}/yt_trending/daily`;    
  },
  methods: {
    checkInputAndSearch() {
      this.fetchResults();
    },
    
    updateWeekStart() {
      // Convert week input (YYYY-W##) to a YYYY-MM-DD (start of that week)
      const [year, week] = this.week_input.split('-W');
      if (year && week) {
        const simpleDate = new Date(year, 0, 1 + (week - 1) * 7);
        // Adjust to the start of the ISO week (Monday)
        const dayOfWeek = simpleDate.getDay();
        const diff = simpleDate.getDate() - dayOfWeek + (dayOfWeek === 0 ? -6 : 1);
        const monday = new Date(simpleDate.setDate(diff));
        this.week_start = monday.toISOString().split('T')[0]; // Format: YYYY-MM-DD
      }
    },

    async fetchResults() {
      let token = localStorage.getItem('access_token');

      let params = '';
      if (this.mode === 'daily') {
        //this.api = "/yt_trending/daily"; // Local
        this.api = `${this.baseURL}/yt_trending/daily`;
        params = new URLSearchParams({
          day_start: this.day_start,
          trend_category: this.trend_category,
          video_type: this.ooOnly ? 'own' : 'all'
        }).toString();
      } else {
        //this.api = "/yt_trending/weekly"; // Local
        this.api = `${this.baseURL}/yt_trending/weekly`;
        params = new URLSearchParams({
          week_start: this.week_start,
          trend_category: this.trend_category,
          video_type: this.ooOnly ? 'own' : 'all'
        }).toString();
      }

      try {
        const response = await axios.get(`${this.api}?${params}`, {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        });
        const data = response.data.results;
        if (data && Array.isArray(data)) {
          this.columns.forEach((column, index) => {
            this.columns[index].results = data
          });
        }
      } catch (error) {
        console.error('Error fetching results:', error);
      }
    },
  },
};
</script>

<style scoped>
.container {
  max-width: 1200px;
  margin: auto;
  padding: 20px;
  font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;
  color: #333;
}

.page-title {
  font-size: 28px;
  margin-bottom: 24px;
  text-align: center;
  color: #222;
}

.filter-panel {
  display: flex;
  flex-wrap: wrap;
  gap: 20px;
  align-items: flex-end;
  background: #f5f5f5;
  padding: 20px;
  border-radius: 10px;
  margin-bottom: 30px;
  box-shadow: 0 2px 8px rgba(0,0,0,0.05);
}

.form-group {
  display: flex;
  flex-direction: column;
  min-width: 200px;
}

.label {
  font-weight: 600;
  margin-bottom: 6px;
}

.radio-group {
  display: flex;
  gap: 10px;
}

input[type="date"],
input[type="week"],
select {
  padding: 8px;
  border: 1px solid #ccc;
  border-radius: 6px;
  font-size: 14px;
}

.submit-button {
  padding: 10px 20px;
  background-color: #0066ff;
  color: #fff;
  font-weight: bold;
  border: none;
  border-radius: 6px;
  cursor: pointer;
  transition: background 0.3s ease;
  margin-top: 24px;
}

.submit-button:hover {
  background-color: #0047b3;
}

.video-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));
  gap: 24px;
}

.video-card {
  display: contents;
}

.video-tile {
  background: #fff;
  border-radius: 10px;
  overflow: hidden;
  box-shadow: 0 2px 10px rgba(0,0,0,0.08);
  transition: transform 0.2s ease;
  display: flex;
  flex-direction: column;
}

.video-tile:hover {
  transform: translateY(-5px);
}

.video-thumb {
  width: 100%;
  object-fit: cover;
  aspect-ratio: 16/9;
}

.video-meta {
  padding: 16px;
  font-size: 14px;
  line-height: 1.6;
}

.video-title {
  font-size: 16px;
  font-weight: bold;
  margin-bottom: 8px;
  color: #111;
}

/* O&O Styling */
.oo-owned {
  border: 2px solid #ff6f00;
  box-shadow: 0 0 10px rgba(255, 111, 0, 0.4);
}
</style>
